import * as businessTypesApi from "src/api/business-types";

export function useBusinessTypes() {
  const businessTypes = ref([]);
  const businessTypesFilter = ref({});

  const initBusinessTypes = async () => {
    try {
      const response = await businessTypesApi.index();

      businessTypes.value = response?.data?.data;

      businessTypesFilter.value = useFilter({
        entities: businessTypes,
        entity: "businessTypes",
      });
    } catch (error) {
      console.error(error);
    }
  };

  const selectBusinessType = async (constitutionOfBusiness) => {
    await initBusinessTypes();

    const escapedConstitutionOfBusiness = constitutionOfBusiness?.replaceAll(
      /[.*+?^${}()|[\]\\]/g,
      String.raw`\$&`,
    );
    const pattern = new RegExp("^" + escapedConstitutionOfBusiness + "$", "i");

    return unref(businessTypesFilter.value?.entities)?.find((businessType) => {
      return pattern.test(businessType.constitution_of_business);
    });
  };

  //get shopname or org name
  const getShopName = (code) => {
    return ["SP", "OPC", "HUF"].includes(code)
      ? "tradeNameOfBusiness"
      : "legalNameOfBusiness";
  };

  onBeforeMount(initBusinessTypes);

  return {
    getShopName,
    businessTypesFilter,
    initBusinessTypes,
    selectBusinessType,
  };
}
